import { axios } from '../../services/axios';

export default async function updateServiceProfiles({
    type,
    level,
    payload,
    scope,
}) {
    const result = await axios.put(
        `/serviceprofile/${type}/${level}`,
        payload,
        { _requestScopeOverride: scope },
    );
    return result;
}
